const init = () => {

  const inputElements = [...document.querySelectorAll('.tryoutstestpage input, .tryoutstestpage textarea')];

  inputElements.forEach(element =>
    element.addEventListener('paste', e => e.preventDefault()),
  );

  const tryoutsTestForm = document.querySelector('.tryouts-test-form');
  if (tryoutsTestForm) {
    const tryoutsTestButtonList = document.querySelectorAll('.tryouts__test-actions-button');
    tryoutsTestForm.addEventListener('submit', (e) => {
      tryoutsTestButtonList.forEach(el => {
        el.classList.add("tryouts-input-disabled");
      })
    })
  }
};

const tryoutsTestSubmit = {
  init,
};

export default tryoutsTestSubmit;
